<div class="billing-report-grid-container px-3 search-holder">
  <ul class="list-inline grid-top-actions mb-3">
    <li class="list-inline-item ">
      <input
        type="text"
        placeholder="{{ 'pages.newRetailer.search' | translate }}"
        matInput
        class="
          rounded-pill
          px-3
          py-2
          mb-1
          border-0
          bg-light
          w-100
          me-0
          input-search
          ms-3
        "
        (keyup)="quickSearch()"
        [(ngModel)]="searchValue"
      />
      <i
        color="primary"
        class="search-icon-holder"
        matSuffix
        mat-icon-button
        aria-label="Search"
      >
        <mat-icon>search</mat-icon>
      </i>
    </li>

    <li class="list-inline-item float-end">
      <button [disabled]="isButtonDisabled" mat-stroked-button class="bg-theme" (click)="exportData()">
        <span translate class="translate">pages.newRetailer.download</span>
        <i class="mi mi-save-alt"></i>
      </button>
    </li>

    <li class="list-inline-item float-end mx-2">
      <button
        mat-stroked-button
        class="ms-3"
        (click)="manageSelectedPromotion()"
        [disabled]="!showManagePromotion" 
      >
      <ng-container *ngIf="((userRole === 'Super Admin') || (userRole === 'Sub Admin')) else otherRoles">
        <span translate class="translate" >
          <i class="mi mi-card-membership small-icon"></i> {{'pages.PromotionCarrierPromotions.Managepromotion' | translate }}</span>
      </ng-container>
      <ng-template #otherRoles>
        <span  >
          <i class="mi mi-card-membership small-icon"></i> {{'pages.PromotionCarrierPromotions.viewPromotion' | translate }}</span>
      </ng-template>
      </button>
    </li>
    <li class="list-inline-item float-end mx-2" [ngStyle]="{'display': userRole === 'Super Admin' || userRole === 'Sub Admin' ? 'block':'none'}">
      <button mat-stroked-button class="ms-3" 
      (click)="createNewPromotion()">
        <span translate class="translate">
          <i class="mi mi-add small-icon pb-2"></i> {{'pages.PromotionCarrierPromotions.NewPromotion' | translate }}</span
        >
      </button>
    </li>
  </ul>
  <div class="report-grid">
    <ag-grid-angular
      style="width: 100%; height: 65vh"
      class="ag-theme-material"
      [rowHeight]="40"
      [enableFilter]="true"
      [enableSorting]="true"
      [enableColResize]="true"
      [rowSelection]="'single'"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
    >
    </ag-grid-angular>
  </div>
</div>
